// Canonical route registry. Single source of truth for the sidebar nav,
// the chord-shortcut handler, the chord-help dialog, and the command
// palette navigate group. When adding or removing a route, edit this
// file only — the four consumers derive their lists from here.

import {
  LayoutDashboard,
  Sparkles,
  ShieldCheck,
  History,
  Settings,
  Wallet,
  Activity,
  Gauge,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type RoutePath =
  | '/'
  | '/positions'
  | '/signals'
  | '/rules'
  | '/performance'
  | '/activity'
  | '/history'
  | '/settings';

export type RouteEntry = {
  to: RoutePath;
  label: string;
  icon: LucideIcon;
  /** Single key pressed after the 'g' chord prefix. */
  chord: string;
};

export const ROUTES: readonly RouteEntry[] = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, chord: 'h' },
  { to: '/positions', label: 'Positions', icon: Wallet, chord: 'p' },
  { to: '/signals', label: 'Signals', icon: Sparkles, chord: 's' },
  { to: '/rules', label: 'Rules', icon: ShieldCheck, chord: 'r' },
  { to: '/performance', label: 'Performance', icon: Gauge, chord: 'e' },
  { to: '/activity', label: 'Activity', icon: Activity, chord: 'a' },
  { to: '/history', label: 'History', icon: History, chord: 'i' },
  { to: '/settings', label: 'Settings', icon: Settings, chord: ',' },
] as const;
